/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import type { V1CheckPhoneRequest } from '../../entities/v1/CheckPhoneRequest'
import type { ToZod } from '@kubb/plugin-zod/utils'
import { z } from 'zod'

export const v1CheckPhoneRequestSchema = z.object({
  phone: z.number().int(),
}) as unknown as ToZod<V1CheckPhoneRequest>